/* eslint-disable import/no-unresolved */


const processInclude = require('base/util');
const giftCert = require('./giftcert/giftcert');

$(document).ready(() => {
    processInclude(giftCert);
});
